export default __webpack_public_path__ + "static/media/1936.f7cf0dbb.png";